import React, { useState } from 'react';
import { Menu, MenuItem, IconButton, Divider } from '@material-ui/core';
import SettingsIcon from '@material-ui/icons/Settings';

const MenuGestionGroupe = () => {
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);

    const handleMenuClick = (event) => {
        event.stopPropagation(); // Empêche la propagation de l'événement pour éviter la fermeture automatique du menu
        setMenuAnchorEl(event.currentTarget); // Ouvre le menu au niveau de l'élément cliqué
    };

    const handleMenuClose = (event) => {
        event.stopPropagation();
        setMenuAnchorEl(null); // Ferme le menu lorsqu'une option est sélectionnée
    };

    return (
        <div>
            <IconButton onClick={handleMenuClick}>
                <SettingsIcon />
            </IconButton>
            <Menu
                anchorEl={menuAnchorEl}
                open={Boolean(menuAnchorEl)}
                onClose={handleMenuClose}
            >
                <MenuItem onClick={handleMenuClose}>Gérer les membres</MenuItem>
                <MenuItem onClick={handleMenuClose}>Modifier</MenuItem>
                <MenuItem onClick={handleMenuClose}>Supprimer le groupe</MenuItem>
                <MenuItem onClick={handleMenuClose}>Vider le groupe</MenuItem>
                <Divider />
                <MenuItem onClick={handleMenuClose}>Information activité</MenuItem>
                <MenuItem onClick={handleMenuClose}>Information tshirt</MenuItem>
                <MenuItem onClick={handleMenuClose}>Générer Fiches bénévoles</MenuItem>
                <MenuItem onClick={handleMenuClose}>Exporter (Excel)</MenuItem>
            </Menu>
        </div>
    );
};

export default MenuGestionGroupe;
